import React, { useEffect } from "react";
import Stage from "../../../../components/Stage";
import { useParams } from "react-router-dom";

const ThankYou = () => {
    const [namePage, setNamePage] = React.useState("");
    const [pathImage, setPathImage] = React.useState("");
    const { formName } = useParams();
    console.log('Datos de TY:', formName);
    const titleStage = formName
        ? formName.includes("accesorios")
            ? "Audi Accesorios"
            : "Audi Collection"
        : "Información de artículo";
    const positionStage = formName ? "top" : "bottom";

    useEffect(() => {
        const path = window.location.pathname;
        const pathName = path.split("/")[2];
        const capitalizedPathName = pathName.charAt(0).toUpperCase() + pathName.slice(1);

        if (capitalizedPathName === "Accesorios") {
            const imageName = formName 
                ? "asset_form_audi_accesorios.jpg" 
                : "form_accesorios-collection_header.jpg";
                
            setPathImage(`${process.env.REACT_APP_RESOURCES_IMAGES_PATH}formsSalesforce/${imageName}`);
        } else if (capitalizedPathName === "Collection") {
            const imageName = formName 
                ? "banner_form_audi_collection_flipbook.jpg" 
                : "banner_form_audi_collection_gracias.jpg";
                
            setPathImage(`${process.env.REACT_APP_RESOURCES_IMAGES_PATH}formsSalesforce/${imageName}`);
        }
        setNamePage(capitalizedPathName);

        document.title = capitalizedPathName + " - Gracias";
    }, [formName]);

    return (
        <>
            <div className="">
                <Stage title={titleStage} img={pathImage} positionTitle={positionStage} />
                <section className="container mt-5 pt-5 pb-5">
                    <div className="row pt-5">
                        <div className="col-12">
                            <h1 className="text-center">Gracias por contactarnos</h1>
                            <p className="text-center mt-5 pt-4 mb-5">Estamos procesando tu solicitud. Un asesor de nuestro equipo se pondrá en contacto contigo a la brevedad.</p>
                            <div className="d-flex justify-content-center mb-5 pb-5">
                                <a className='button-home mt-5 mb-5' href={namePage === "Accesorios" ? process.env.REACT_APP_URL_HOME_ACCESORIOS : process.env.REACT_APP_URL_HOME_COLLECTION} target="_parent">
                                    Volver al Home
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default ThankYou;